module.exports = __webpack_public_path__ + "fonts/LINESeedSans_A_Bd.cc43eb8c.otf";